import React from 'react';
import EmptyViewDefault from './EmptyViewDefault';

const EmptyView = () => <EmptyViewDefault />;

export default EmptyView;
